<template>
  <v-container grid-list-xl>
    <v-layout row justify-center align-center wrap class="mt-4 pt-2">
      <v-flex xs12 sm12 md12 lg12 xl12>
        <h2 class="pl-4">
          <span>I can help you</span>
          <span class="blue--text"> out with</span>
        </h2>
      </v-flex>
      <v-flex v-for="service in services" :key="service.src" xs6 sm3 md3 lg3 xl3>
        <v-card hover flat class="service-card" color="transparent" :style="{'cursor':'context-menu'}">
          <v-card-title></v-card-title>
          <v-img
            :src="service.src"
            :height="service.height"
            aspect-ratio="2.75"
            :alt="'Midhun do '+service.title"
            lazy-src="https://unra.go.ug/assets/loaders/loader_2.gif"
            contain
          ></v-img>
          <v-card-title class="justify-center">
            <v-flex text-xs-center subheading font-weight-bold>{{service.title}}</v-flex>
          </v-card-title>
        </v-card>
      </v-flex>
      <v-flex xs12 sm12 md12 lg12 xl12>
        <h2 class="pl-4">
          <span>Worked</span>
          <span class="blue--text">with</span>
        </h2>
      </v-flex>

      <v-flex v-for="client in clients" :key="client.src" xs6 sm4 md3 lg2 xl2>
        <v-card flat :href="client.href" target="_blank" color="white">
          <v-hover>
            <v-img
              slot-scope="{ hover }"
              :src="client.src"
              :alt="client.name+' logo'"
              lazy-src="https://unra.go.ug/assets/loaders/loader_2.gif"
              height="100"
              width="160"
              aspect-ratio="2.75"
              contain
            >
              <v-expand-transition>
                <div
                  v-if="hover"
                  class="worked-with transition-fast-in-fast-out"
                  style="height: 100%;"
                >
                {{client.name}}
                </div>
              </v-expand-transition>
            </v-img>
          </v-hover>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  metaInfo: {
    title: "Services",
    titleTemplate: "%s ← Midhun Nair",
    meta: [
      { name: "viewport", content: "width=device-width, initial-scale=1" },
      {
        name: "description",
        content:
          "Midhun Nair's Services Web Development Video Editing Graphic Design Front-End Advertising Digital Marketing"
      },
      { charset: "utf-8" },
      { property: "og:title", content: "Midhun Nair" },
      { property: "og:site_name", content: "Midhun Nair" },
      { property: "og:type", content: "website" },
      { property: "og:url", content: "http://midhunnair.live" },
      {
        property: "og:image",
        content: "https://cdn.image4.io/mndesigns/f_auto/66aa3e55-542a-4355-acb3-2602e5d55414.png"
      },
      {
        property: "og:description",
        content:
          "Midhun Nair's Services Web Development Video Editing Graphic Design Front-End Advertising Digital Marketing"
      }
    ]
  },
  data() {
    return {
      clients: [
        {
          name: "Silver Oak University",
          src: "https://firebasestorage.googleapis.com/v0/b/mn-portfolio.appspot.com/o/worked%20with%2Fsou.png?alt=media&token=9b9eead9-b0fb-4907-8dab-f41c016b220f",
          href: "http://www.silveroakuni.ac.in/"
        },
        {
          name: "Silver Oak University IEEE SB",
          src: "https://firebasestorage.googleapis.com/v0/b/mn-portfolio.appspot.com/o/worked%20with%2Fieeesou.png?alt=media&token=8bb9c711-51e6-404b-879d-b247537dd155",
          href: "http://ieee.silveroakuni.ac.in/"
        },
        {
          name: "Markinfinity",
          src: "https://firebasestorage.googleapis.com/v0/b/mn-portfolio.appspot.com/o/worked%20with%2Fmarkinfinity.png?alt=media&token=bcd7a3a0-93c8-4c3c-8dc7-26e175b285db",
          href: "http://www.markinfinity.in/"
        },
        {
          name: "Saint Hilary School",
          src:
            "https://firebasestorage.googleapis.com/v0/b/mn-portfolio.appspot.com/o/worked%20with%2Fstsh.png?alt=media&token=8ee57405-f567-4ae7-84af-5f075f16369e",
          href: "#"
        },
        {
          name: "Mishra Educational Institute",
          src: "https://firebasestorage.googleapis.com/v0/b/mn-portfolio.appspot.com/o/worked%20with%2Fmei.png?alt=media&token=8a103875-440c-4430-b98a-5d5bf2ed7b63",
          href: "http://mishraeducationalinstitute.in"
        },
      ],
      services: [
        {
          src: "https://i.imgur.com/GvTt5GG.png",
          title: "Web Development",
          height: "100"
        },
        
        {
          src: "https://i.imgur.com/g74mGuU.png",
          title: "Web Design",
          height: "100"
        },
        
        {
          src: "https://firebasestorage.googleapis.com/v0/b/mn-portfolio.appspot.com/o/services%2Fgraphic%20designing.png?alt=media&token=7044b891-7828-48f2-b4e4-7058ff1d3843",
          title: "Graphic Designing ",
          height: "100"
        },

        {
          src: "https://i.imgur.com/wXLtLKy.png",
          title: "Video Editing",
          height: "100"
        },
        {
          src: "https://i.imgur.com/tcZnDep.png",
          title: "Digital Marketing",
          height: "100"
        },
        {
          src: "https://firebasestorage.googleapis.com/v0/b/mn-portfolio.appspot.com/o/services%2Fsocial%20media%400.5x.png?alt=media&token=a0cbae18-b928-41f6-97dc-fd690bd30533",
          title: "Social Media Post & Stories Designing",
          height: "170"
        },
        {
          src: "https://firebasestorage.googleapis.com/v0/b/mn-portfolio.appspot.com/o/services%2Fweb%20development.png?alt=media&token=1f98a30b-560f-4bd1-af86-dfc86dcaa285",
          title: "Website Hosting & Maintaining",
          height: "200"
        }
      ]
    };
  }
};
</script>
<style >
.v-img--reveal {
  opacity: 0.3;
}

.worked-with{
  display:flex;
  justify-content: center;
  align-items: center;
  position: relative;
  color:#fff;
  font-weight: 600;
  text-align: center;
  background-color: #2195f359;
  backdrop-filter: blur(3px);
}
</style>